import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ErrorBoundary from './ErrorBoundaryMain';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { CssBaseline } from '@mui/material';
import { App } from './App';

const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ErrorBoundary>
                    <CssBaseline />
                    <App />
                </ErrorBoundary>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);

serviceWorkerRegistration.register();
